module.exports = __webpack_public_path__ + "img/itx-file-type-oga.4f2fd5a6.svg";